import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DialogService, HttpService, ResponseMessage, ServiceResponse } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { environment } from 'src/environments/environment';
import { StationSet } from 'src/tmc-yard/client/model/station-set';
import { CancelPlannedAssignment, CreatePlannedAssignment, PlannedTransportAssignment, RoutingPositionOption, RoutingPositionOptionSelection } from './../../model/sac-client.model';
import { SelectRoutingPositionComponent } from './select-routing-position/select-routing-position.component';
import { Station } from 'src/tmc-yard/client/model/station';

@Component({
  selector: 'app-manage-planned-assignments',
  templateUrl: './manage-planned-assignments.component.html',
  styleUrls: ['./manage-planned-assignments.component.scss']
})
export class ManagePlannedAssignmentsComponent implements OnInit {

  plannedTransportAssignments = new Array<PlannedTransportAssignment>();

  responseMessages: ResponseMessage[];
  isLoading = false;

  selectedTransportId: number;
  selectedPlannedTransportAssignmentId: number;

  targetStation: Station;
  stationSet: StationSet;

  constructor(
    public translationService: TranslationService,
    private httpService: HttpService,
    private dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.targetStation = data.station;
    this.stationSet = data.stationSet;
    console.log('data is', data);
  }

  ngOnInit(): void {
    this.loadPlannedTransportAssignments();
  }

  transportSelected(transportId: number) {
    this.selectedTransportId = transportId;
  }

  public createPlannedAssignment() {
    if (this.selectedTransportId != null) {

      this.isLoading = true;
      this.responseMessages = [];

      const dto = new RoutingPositionOptionSelection();
      dto.transport = { id: this.selectedTransportId };
      dto.targetStation = { id: this.targetStation?.id };

      this.httpService.postWithContext<RoutingPositionOption[]>(`${environment.sacClientEndpoint}/position-options`, dto)
        .subscribe(options => {
          this.isLoading = false;
          if (options.length == 1) {
            this.savePlannedAssignment(options[0].routingPositionId);
          } else {
            this.dialogService.openMiddle(SelectRoutingPositionComponent, { routingPositionOptions: options }).afterClosed().subscribe(routingPositionId => {
              if (routingPositionId) {
                this.savePlannedAssignment(routingPositionId);
              }
            });
          }
        }, error => {
          console.error(error);
          this.isLoading = false;
        });
    }
  }

  private savePlannedAssignment(routingPositionId: number) {
    const dto = new CreatePlannedAssignment();
    dto.plannedTransport = { id: this.selectedTransportId };
    dto.targetStation = { id: this.targetStation.id };
    dto.targetRoutingPosition = { id: routingPositionId };

    this.httpService.postWithContext<ServiceResponse>(`${environment.sacClientEndpoint}/plan-transport-assignment`, dto)
      .subscribe(response => {
        this.responseMessages = response.responseMessages;
        this.isLoading = false;
        this.loadPlannedTransportAssignments();
      }, error => {
        console.error(error);
        this.isLoading = false;
        this.loadPlannedTransportAssignments();
      });
  }

  public cancelPlannedAssignment() {
    if (this.selectedPlannedTransportAssignmentId != null) {
      this.dialogService.showConfirm('tmc-yard.widgets.sac-client.manage-planned-assignments.cancel.confirm-dialog.title',
        'tmc-yard.widgets.sac-client.manage-planned-assignments.cancel.confirm-dialog.message').afterClosed().subscribe((result) => {
          if (result) {
            this.performCancel();
          }
        });
    }
  }

  private performCancel() {
    this.isLoading = true;
    this.responseMessages = [];

    const dto = new CancelPlannedAssignment();
    dto.transportAssignment = { id: this.selectedPlannedTransportAssignmentId };

    this.httpService.postWithContext<ServiceResponse>(`${environment.sacClientEndpoint}/cancel-planned-assignment`, dto)
      .subscribe(response => {
        this.responseMessages = response.responseMessages;
        this.isLoading = false;
        this.loadPlannedTransportAssignments();
      }, error => {
        console.error(error);
        this.isLoading = false;
        this.loadPlannedTransportAssignments();
      });
  }

  public setSelectedAssignment(plannedAssignment: PlannedTransportAssignment) {
    this.selectedPlannedTransportAssignmentId = plannedAssignment.transportAssignmentId;
  }

  private loadPlannedTransportAssignments() {
    if (this.targetStation.id != null) {
      this.httpService.postWithContext<PlannedTransportAssignment[]>(`${environment.sacClientEndpoint}/planned-transport-assignments`,
        { id: this.targetStation.id })
        .subscribe(response => {
          const plannedTransportAssignments = new Array<PlannedTransportAssignment>();
          for (const detail of response) {
            plannedTransportAssignments.push(new PlannedTransportAssignment(detail));
          }
          this.plannedTransportAssignments = plannedTransportAssignments;
          this.isLoading = false;
        }, error => {
          console.error(error);
          this.isLoading = false;
        });
    }
  }
}
